import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { FilterModel } from "src/app/shared/models";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root',
})
export class MediaAppService {

    private apiEndPoint = environment.apiBaseUrl + 'api/mediaApp/';

    constructor(private http: HttpClient) { }

    getPagedResult(model: FilterModel) {
        return this.http.get(this.apiEndPoint + 'paged-result?' + model.toQueryString());
    }
}